export default __webpack_public_path__ + "static/media/he.182965cd.svg";